/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @return {?}
 */
export function supportsState() {
    return !!window.history.pushState;
}
//# sourceMappingURL=history.js.map


// WEBPACK FOOTER //
// ../../../packages/platform-browser/esm5/src/browser/location/history.js